module.exports = __webpack_public_path__ + "img/Tick Icon.4b39d9b3.svg";